import script from "./PersonItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonItem.vue?vue&type=script&setup=true&lang=ts"

import "./PersonItem.vue?vue&type=style&index=0&id=a624c70a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a624c70a"]])

export default __exports__